var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBitcoinMono = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 20",
    width: 50,
    height: 50,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M31.79 26.036c-.219-.514-.556-.965-1.232-1.344-.349-.2-.724-.351-1.114-.446.263-.125.504-.29.715-.492.31-.282.546-.64.684-1.04.128-.406.18-.833.154-1.259-.049-.75-.193-1.477-.58-2-.385-.522-.929-.924-1.648-1.205-.553-.214-1.118-.348-1.995-.397V15H25.02v2.857h-1.404V15h-1.798v2.857H18V20h1.222c.382 0 .64.036.772.103.122.053.223.148.285.268.057.111.083.375.083.78v7.733c0 .402-.026.66-.083.777-.057.116-.088.218-.224.281-.136.062-.14.058-.517.058H18.38L18 32.143h3.815V35h1.798v-2.857h1.403V35h1.755v-2.875c1.14-.058 1.951-.21 2.604-.46.847-.321 1.496-.79 1.96-1.406.466-.616.615-1.558.655-2.286.03-.647 0-1.482-.2-1.937zm-8.177-5.768h1.403v3.303h-1.403v-3.303zm0 9.464v-4.018h1.403v4.018h-1.403zm3.158-9.29c.263.112.434.335.605.567.188.254.285.594.285.955 0 .349-.127.648-.33.915-.166.22-.297.371-.56.496v-2.933zm1.263 8.335c-.342.308-.54.45-.97.616-.096.034-.194.063-.293.085V25.78c.171.026.338.077.495.152.342.147.667.308.868.59.224.322.346.707.351 1.102-.001.487-.124.857-.453 1.152h.002z",
    transform: "translate(-18 -15)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBitcoinMono);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bitcoin-mono.72c87e5f77a3a6258f13f1d8c6b8affd.svg";